import { Environment } from './environment.interface';

// Helper function to get required runtime variables and throw a clear error if they are missing.
function getRequiredEnv(key: string, fallback?: string): string {
  const value = (window as any)?.env?.[key];
  if (value) { return value; }
  if (fallback !== undefined) { return fallback; }
  throw new Error(`FATAL: Required runtime environment variable "${key}" is missing.`);
}

//const version = getRequiredEnv('version');
const clientId = getRequiredEnv('clientId', 'clientId-placeholder');
const tenantId = getRequiredEnv('tenantId', 'tenantId-placeholder');
const avatarUrl = getRequiredEnv('avatarUrl', '');
const profileUrl = getRequiredEnv('profileUrl', 'http://localhost:8080');
const mapsBackendApi = '/api/';

export const environment: Environment = {
  production: true,
  defaultLanguage: 'en',
  authLogLevel: 2, // INFO
  pageSize: 10,
  activeOnly: true,
  roles: {
    user: 'User',
    superUser: 'Admin'
  },
  pageSizes: '10,25,50,100',
  loadingSkeletonSize: 10,
  version: 'v3.8.3',
  mapsBackendApi: mapsBackendApi,
  avatarUrl: avatarUrl,
  profileUrl: profileUrl,
  oidc: {
    issuer: `https://login.microsoftonline.com/${tenantId}/v2.0`,
    clientId: clientId,
    scope: `openid profile email api://${clientId}/User.Read`
  },
};
